import React from 'react';
import { View } from 'styleguide/View';
import AlienAbduction from 'assets/alien-abduction.svg';
import { DisplayXS, TextMD } from 'styleguide/Texts';
import { Spacing } from 'styleguide/spacing';

export const FolderNotFoundView = () => {
  return (
    <View
      style={{
        height: 400,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AlienAbduction />
      <DisplayXS
        style={{
          textAlign: 'center',
          marginTop: Spacing.md,
          marginBottom: Spacing.md,
        }}
      >
        Folder not found
      </DisplayXS>
      <TextMD style={{ textAlign: 'center', maxWidth: 300 }}>
        This folder might not exist anymore. Make sure you have the right link.
      </TextMD>
    </View>
  );
};
